import React from 'react';
import { ModalFooter } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';

/**
 * Componente de rodapé para o formulário de importação de dados com botões de envio e cancelamento.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {Function} props.onCancel - Função a ser chamada quando o botão cancelar for clicado
 * @param {boolean} props.isSubmitting - Indicador de que o formulário está sendo enviado
 * @param {boolean} props.hasFile - Indicador de que um arquivo foi selecionado para importação
 * @param {boolean} props.isLoading - Indicador de que o componente está em estado de carregamento
 * @returns {JSX.Element} A renderização do rodapé com botões de ação
 */

const ImportFormFooter = ({ onCancel, isSubmitting, hasFile, isLoading }) => {
  return (
    <ModalFooter>
      <ReactButton
        btnColor="confirmation"
        type="submit"
        form="import-data-form"
        disabled={!hasFile || isSubmitting || isLoading}
      >
        {isSubmitting ? 'Importando...' : 'Importar'}
      </ReactButton>
      <ReactButton
        btnColor="cancelation"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancelar
      </ReactButton>
    </ModalFooter>
  );
};

export default ImportFormFooter;
